module.exports = __webpack_public_path__ + "static/media/cat-final.76049ec0.svg";